import classNames from 'clsx';
import React from 'react';
import Slider from 'react-slick';

import type { Carousel } from '@swf/cms';

import styles from './CMSCarousel.scss';
import CMSCarouselItem from './CMSCarouselItem/CMSCarouselItem';

const Arrow = ({
  onClick,
  type
}: {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  type: 'prev' | 'next';
}) => (
  <button type="button" className={classNames(styles.arrow, styles[`${type}`])} onClick={onClick}>
    <span className={styles[`${type}Arrow`]} />
  </button>
);

const CMSCarousel: React.FC<Carousel> = ({
  auto_rotate: autoRotate,
  rotation_speed: rotationSpeed,
  slides
}) => {
  const isMinNumberOfSlides = slides.length === 3;
  const slideSpeed = Number(rotationSpeed) * 1000;

  if (slides.length < 3) {
    return null;
  }

  return (
    <div className={styles.cmsCarousel}>
      <Slider
        arrows
        autoplay={autoRotate}
        autoplaySpeed={slideSpeed}
        centerMode
        centerPadding={'0'}
        className={'center'}
        dots
        infinite
        speed={slideSpeed || 500}
        slidesToShow={3}
        nextArrow={<Arrow type="next" />}
        prevArrow={<Arrow type="prev" />}
        variableWidth
        adaptiveHeight
        responsive={[
          {
            breakpoint: 725,
            settings: {
              slidesToShow: 1,
              centerPadding: '0'
            }
          }
        ]}
      >
        {slides.map(({ slide }, key) => (
          <CMSCarouselItem key={key} slide={slide} />
        ))}
        {isMinNumberOfSlides &&
          slides.map(({ slide }, key) => <CMSCarouselItem key={key} slide={slide} />)}
      </Slider>
    </div>
  );
};
export default CMSCarousel;
